// extracted by mini-css-extract-plugin
module.exports = {"centerMode":"ProductWidget_centerMode__kuq7V","scrollbar":"ProductWidget_scrollbar__ZmlWM"};